export default "__VITE_ASSET__CcbDjlhC__"